import { russianRegExp } from "appConstants/regexp";

export const validateRussianLetter = (value: string): boolean => {
  const hasRussianSymbols = russianRegExp.test(value);
  return !hasRussianSymbols;
};
